import { useContext } from 'react'
import { useParams } from 'lib/router'
import { useStore } from 'state/store'
import { Incentive } from 'views/Incentive'
import Loading from 'components/Loading'
import { RemoteConfigContext } from 'lib/remoteConfig/RemoteConfigContext'
import ComingSoon from 'views/ComingSoon'

export const IncentiveContainer = () => {
  const organizationId = useStore(state => state.organization.id)
  const workspaceId = useStore(state => state.workspace.id)
  const currencyCode = useStore(state => state.workspace.currencyCode)
  const timezone = useStore(state => state.workspace.timezone)
  const { incentivePlanId } = useParams<{ incentivePlanId: string }>()

  const { getBoolean } = useContext(RemoteConfigContext)
  const incentivesEnabled = getBoolean('hera_incentive_plans')

  if (!workspaceId || !organizationId || !currencyCode || !timezone) {
    return <Loading />
  }
  if (incentivesEnabled) {
    return (
      <Incentive
        organizationId={organizationId}
        workspaceId={workspaceId}
        incentivePlanId={incentivePlanId}
        currencyCode={currencyCode}
        timezone={timezone}
      />
    )
  }

  return (
    <ComingSoon
      title="pmportal.incentives.title"
      description="pmportal.incentives.description"
    />
  )
}
